import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row, Button, Form } from "react-bootstrap";

import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
// eslint-disable-next-line no-unused-vars
import Select from "react-select";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import { useSelector } from "react-redux";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import axios from "axios";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
const EditPropertySubType = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.token;
  // eslint-disable-next-line no-unused-vars
  const userId = loggedInUser?.userDetails?.id;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [states, setStates] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedCountry, setSelectedCountry] = useState("");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { propertySubTypeId } = useParams();
  console.log(propertySubTypeId);
  const editCityApi = Api({
    url: `property/sub/type/edit`,
  });

  // eslint-disable-next-line no-unused-vars
  const [selectedUserType, setSetelectedUserType] = useState("");
  // eslint-disable-next-line no-unused-vars
  const getUserTypeApi = Api({
    url: `property/sub/type/${propertySubTypeId}`,
  });
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  useEffect(() => {
    const fetchPostData = async () => {
      try {
        setIsLoading(true);
        // const response = await getUserTypeApi.fetchData();
        // console.log(response);
        const response = await axios.get(
          `${baseUrl}/property/sub/type/${propertySubTypeId}`,

          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response?.data?.statusType === "SUCCESS") {
          console.log(response);
          const postData = response.data.propertySubType;
          console.log(postData);
          setFormData({
            name: postData.name,
            description: postData.description,
          });
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        showToast("Error Occurred", { type: "error" });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPostData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const data = {
        id: propertySubTypeId,
        name: formData.name,
        description: formData.description,
      };
      console.log(data);
      const responseData = await editCityApi.editData(data);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Property Sub Type  Updated successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/property-subtype");
        }, 3000);
      }

      //   console.log(data);
    } catch (error) {
      setIsError(true);
      console.log(error);
      showToast("Error Occured", {
        type: "error",
      });
    }
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Property Sub Types", link: "/property-subtype" },
    { label: "Edit Property Sub Type", link: "", active: true },
  ];
  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Edit Property Sub Type Details"
              description="Edit property sub type section"
            />
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="title"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
                <Col md={12}>
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="description"
                      placeholder="Enter Description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                  </div>
                </Col>
              </Row>

              <Button variant="primary" type="submit" className="mt-5 mb-5">
                {isLoading ? <Spinner loading={true} /> : "Update"}
              </Button>

              <Link
                style={{ marginLeft: "1rem" }}
                className="btn btn-primary mb-5 mt-5"
                to={"/city"}
              >
                Back
              </Link>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditPropertySubType;
